module.exports = __webpack_public_path__ + "static/media/C++.411e8da5.png";